import { lazy, Suspense, useEffect } from "react";
/// Components
import { useSelector } from "react-redux";
import { Route, Routes, useLocation, useNavigate, useParams } from "react-router-dom";
import Index from "./jsx/index";
// action
import { ToastContainer } from "react-toastify";
import "./css/style.css";
import 'bootstrap-icons/font/bootstrap-icons.css';
import ForgotPassword from "./jsx/pages/auth/ForgotPassword";
import VerifyEmailRedirect from "./jsx/pages/auth/VerifyEmailRedirect";
import ResendVerificationEmail from "./jsx/pages/auth/ResendVerificationEmail";
import { useStorageListener } from "./hooks/useStorageListener";
import { initMetaPixel } from "./jsx/utils/metaPixel";
import { initGTM } from "./jsx/utils/gtm";

const SignUp = lazy(() => import("./jsx/pages/auth/Signup"));
const Login = lazy(() => {
  return new Promise((resolve) => {
    setTimeout(() => resolve(import("./jsx/pages/auth/Login")), 500);
  });
});

function withRouter(Component) {
  function ComponentWithRouterProp(props) {
    let location = useLocation();
    let navigate = useNavigate();
    let params = useParams();

    return (
      <Component
        {...props}
        router={{ location, navigate, params }}
      />
    );
  }

  return ComponentWithRouterProp;
}

function App() {
  const { isAuthenticated } = useSelector((state) => state.auth);
  const navigate = useNavigate();

  // Use the storage listener hook
  useStorageListener();

  // Initialize Meta Pixel once on app mount
  useEffect(() => {
    initMetaPixel();
    initGTM();
  }, []);

  useEffect(() => {
    if (!isAuthenticated) {
      navigate("/login");
    }
  }, [isAuthenticated]);

  let PublicRoutes = (
    <Routes>
      <Route
        path="/login"
        element={<Login />}
      />
      <Route
        path="/signup"
        element={<SignUp />}
      />
      <Route
        path="/forgot-password"
        element={<ForgotPassword />}
      />
      <Route
        path="/verify-email"
        element={<VerifyEmailRedirect />}
      />
      <Route 
        path="/resend-verification" 
        element={<ResendVerificationEmail />} 
      />

    </Routes>
  );
  if (isAuthenticated) {
    return (
      <>
        <Suspense
          fallback={
            <div id="preloader">
              <div className="sk-three-bounce">
                <div className="sk-child sk-bounce1"></div>
                <div className="sk-child sk-bounce2"></div>
                <div className="sk-child sk-bounce3"></div>
              </div>
            </div>
          }
        >
          <Index />
        </Suspense>
      </>
    );
  } else {
    return (
      <div className="vh-100">
        <ToastContainer />
        <Suspense
          fallback={
            <div id="preloader">
              <div className="sk-three-bounce">
                <div className="sk-child sk-bounce1"></div>
                <div className="sk-child sk-bounce2"></div>
                <div className="sk-child sk-bounce3"></div>
              </div>
            </div>
          }
        >
          {PublicRoutes}
        </Suspense>
      </div>
    );
  }
}

export default withRouter(App);
